module.exports = __webpack_public_path__ + "static/img/admin-mgt1.250a8d53.svg";